import { UserShoppingItemsData } from './user-shopping-items-data';
import { GuestShoppingItemsData } from './guest-shopping-items-data';
import { Injectable } from '@angular/core';
@Injectable()
export class ShoppingItemsDataGateway {
    constructor(
        public guestData: GuestShoppingItemsData,
        public userData: UserShoppingItemsData
    ){

    }
    public getService(uid?): GuestShoppingItemsData|UserShoppingItemsData{
        return uid ? this.userData: this.guestData;
    };
}


// WEBPACK FOOTER //
// ./src/modules/account/providers/shopping-items-data-gateway.ts